import LoadingOverlay from '@/components/loadingOverlay'
import {
  forbidUsingDatabase,
  getIsForbiddenUsingDatabase,
} from '@/utils/database'
import { isInMaintenanceMode } from '@/utils/maintenance'
import { useAuth } from '@clerk/clerk-react'
import {
  Outlet,
  createRootRoute,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const channel = new BroadcastChannel('tab')
channel.postMessage('open')

export const Route = createRootRoute({
  validateSearch: (search: Record<string, unknown>): { id?: string } => {
    return {
      id: (search.id as string) ?? undefined,
    }
  },
  component: () => {
    const { userId, isLoaded } = useAuth()
    const routerState = useRouterState()
    const navigate = useNavigate()
    const { t } = useTranslation()

    // メンテナンスモードの即時チェック（useEffectより先に実行）
    const inMaintenance = isInMaintenanceMode()

    useEffect(() => {
      // メンテナンスモードのチェック
      if (inMaintenance && routerState.location.pathname !== '/maintenance') {
        navigate({
          to: '/maintenance',
        })
        return
      }

      if (!inMaintenance && routerState.location.pathname === '/maintenance') {
        navigate({
          to: '/',
        })
      }
    }, [inMaintenance, routerState, navigate])

    useEffect(() => {
      const listener = (event: MessageEvent) => {
        if (event.data === 'open') {
          forbidUsingDatabase()
          navigate({
            to: '/forbid-multitab',
            search: () => ({}),
          })
        }
      }

      channel.addEventListener('message', listener)

      return () => {
        channel.removeEventListener('message', listener)
      }
    }, [navigate])

    useEffect(() => {
      // メンテナンス中は認証チェックをスキップ
      if (inMaintenance || routerState.location.pathname === '/maintenance') {
        return
      }

      if (!isLoaded) {
        return
      }
      if (
        getIsForbiddenUsingDatabase() &&
        routerState.location.pathname !== '/forbid-multitab'
      ) {
        navigate({
          to: '/forbid-multitab',
        })
      }
      if (
        !getIsForbiddenUsingDatabase() &&
        routerState.location.pathname === '/forbid-multitab'
      ) {
        navigate({
          to: '/',
        })
      }

      if (
        userId === null &&
        routerState.location.pathname !== '/signIn' &&
        routerState.location.pathname !== '/signIn/factor-one' &&
        routerState.location.pathname !== '/waitlist'
      ) {
        navigate({
          to: '/signIn',
        })
      }
      if (
        userId !== null &&
        (routerState.location.pathname === '/signIn' ||
          routerState.location.pathname === '/signIn/factor-one' ||
          routerState.location.pathname === '/waitlist')
      ) {
        navigate({
          to: '/',
        })
      }
    }, [inMaintenance, isLoaded, userId, routerState, navigate])

    // メンテナンス中は認証ロード状態に関わらず画面を表示
    if (!isLoaded && !inMaintenance) {
      return <LoadingOverlay description={t('loading/authenticating')} />
    }

    return (
      <>
        <Outlet />
        {/* <TanStackRouterDevtools position="top-left" /> */}
      </>
    )
  },
})
